import { Menu, Modal } from "antd";
import { QuestionCircleOutlined } from "@ant-design/icons";
import ButtonPair from "components/ButtonPair/ButtonPair";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { logUserEvent } from "helpers/userEventLogger";
import { useOnlineContext } from "helpers/contexts/OnlineContext/OnlineContext";
import { useEntityData } from "EntityDataContext/EntityDataContext";

const GoButton = ({ selected }) => {
  const navigate = useNavigate();

  const {
    copyAssets,
    spaces,
    assets,
    currentSpaceId,
    setCurrentSpaceId,
    setShowCopyDrawer,
    setAssetsToCopyList,
    userData: { email },
    syncStatusHook: { imagesToUploadCount }
  } = useEntityData();

  const { isOnline } = useOnlineContext();

  const { spaceId } = useParams();
  
  const [listCopy, setListCopy] = copyAssets;

  const space = spaces?.items?.[selected?.key] || {}
  const selectedAssets = (assets.assetTree?.[space.facilityId]?.[space.floorId]?.[space.id] || []).map(assetId => {
    return assets.items[assetId]
  })

  useEffect(() => {
    if (currentSpaceId !== spaceId) {
      setCurrentSpaceId(spaceId);

      setListCopy([]);

      setAssetsToCopyList([])
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [spaceId])


  const redirect = () => {
    if (selected.facilityId && selected.floorId && selected.key) {
      navigate(`/space/${selected.key}`);
    }
    if (selected.facilityId && selected.key && !selected.floorId) {
      navigate(`/floor/${selected.key}`);
    }
    if (selected.key && !selected.facilityId && !selected.floorId) {
      navigate(`/facility/${selected.key}`);
    }
  };

  const options = () => {
    return (
      <Menu>
        {" "}
        <Menu.Item
          onClick={() => {
            setTimeout(() => {
              logUserEvent({
                user: email,
                eventType: "Copy Assets option clicked from Go button",
                imageOutboxSize: imagesToUploadCount
              }, isOnline);

              setAssetsToCopyList(selectedAssets)
              setShowCopyDrawer(true)
            }, 10);
          }}
          disabled={
            selectedAssets.length === 0 || !currentSpaceId || !(selected.facilityId && selected.floorId && selected.key)
          }
        >
          Copy Assets
        </Menu.Item>
      </Menu>
    );
  };

  async function confirmLeavePage(e) {
    e.stopPropagation();
    Modal.confirm({
      title: "Copy Assets is not complete. Navigating away from this space will clear the remaining copy assets.",
      icon: <QuestionCircleOutlined />,
      okText: "Clear Assets",
      cancelText: "Cancel",
      onOk: () => {
        logUserEvent({
          user: email,
          eventType: "User navigating away from Copy Assets before all assets copied via Copy Asset modal (Go Button)",
          imageOutboxSize: imagesToUploadCount
        }, isOnline);

        setListCopy([]);
        redirect();
      },
    });
  }

  return (
    <ButtonPair
      label="Go"
      disabled={!selected}
      onClick={listCopy.length > 0 ? confirmLeavePage : redirect}
      options={options}
    />
  );
};

export default GoButton;
